export default __webpack_public_path__ + "static/other-3bb379e26c05bb5272edad59902f65b8.jpg";